import React from "react";
import useStyles from "../style";
import { TextField } from "@material-ui/core";

const InputDecimal = ({ text, setPartnerCode, type, label, name, placeholder, isEnable, isRequired }) => {
    const classes = useStyles();
    const onChange = (e) => {
        let start = e.target.selectionStart;
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;
        setPartnerCode({ ...text, text: value });
        if (val.length > 0) {
            e.target.value = Number(value).toFixed(2);
            e.target.setSelectionRange(start, start);
            setPartnerCode({ ...text, text: Number(value).toFixed(2) });
        }
    }
    const validateField = () => {
        if (text.text != '') {
            setPartnerCode({ ...text, valid: 'true' });
        } else {
            setPartnerCode({ ...text, valid: 'false' });
        }
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>
            <TextField
                InputProps={{
                    classes: {
                        focused: classes.textBorder,
                        input: classes.input,

                    },
                }}
                disabled={isEnable ?? false}
                value={text.text}
                onChange={onChange}
                placeholder={placeholder}
                type={type}
                name={name}
                onKeyUp={validateField}
                onBlur={validateField}
                style={{ width: '85%' }}
                inputStyle={{ width: '85%' }}
            />
        </div>
    );
}

export default InputDecimal;